import React from "react";
import BoxDetailsCard from "../../FormFields/BoxDetailsCard/BoxDetailsCard";

/**
 * MessageA3DE Component
 * Handles UI command "A3DE" to display subscriber box details
 * 
 * Expected data structure:
 * {
 *   "uiCommand": "A3DE",
 *   "data": "{\"boxDetails\":[{\"boxId\":\"007060732120\",\"boxType\":\"https://...\",\"channelsCount\":49,\"monthlyCharge\":277.42,\"appsCount\":28},...],\"currentAccountBalance\":\"10657.82\",\"subscriberId\":\"3001715659\",\"balanceDueDate\":\"Feb 27, 2028\"}",
 *   "code": "1.5.5.5"
 * }
 */
export default function MessageA3DE(props) {
  const { data, text_data, code } = props.item;
  const { tag } = props;

  // Parse the data string if it's a string - check both 'data' and 'text_data' fields
  const rawData = data || text_data;
  let parsedData = rawData;
  if (typeof rawData === "string") {
    try {
      parsedData = JSON.parse(rawData);
    } catch (error) {
      console.error("MessageA3DE: Error parsing data", error);
      parsedData = {};
    }
  }

  const handleBoxClick = (code, data, tag) => {
    if (props.handleClick) {
      props.handleClick(code, data, tag);
    }
  };

  return (
    <BoxDetailsCard
      data={parsedData}
      code={code}
      tag={tag}
      uiCommand="A3DE"
      onClickHandler={handleBoxClick}
    />
  );
}
